<template>
  <div>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog.Detail" persistent max-width="700px" hide-overlay>
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Detail Pembelian</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialog.Detail = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >No. Order</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ TransaksiDetail.no_order }}
              </v-list-item-title>
            </v-col>
            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Status Pembayaran</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 green--text">
                {{ TransaksiDetail.pembayaran_status }}
              </v-list-item-title>
            </v-col>
            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Note</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ TransaksiDetail.note }}
              </v-list-item-title>
            </v-col>
            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Note Detail</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ TransaksiDetail.note_detail }}
              </v-list-item-title>
            </v-col>

            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Nama Pembeli -
                <span style="color:red">{{
                  TransaksiDetail.id_pembeli
                }}</span></v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ TransaksiDetail.nama_pembeli }}
              </v-list-item-title>
            </v-col>

            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Tanggal Pembelian</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ TransaksiDetail.created_at | dateTimeFormat }}
              </v-list-item-title>
            </v-col>

            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Metode Pembayaran</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ TransaksiDetail.metode }}
              </v-list-item-title>
            </v-col>

            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Jenis Iklan</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ TransaksiDetail.jenis_iklan }}
              </v-list-item-title>
            </v-col>
            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Tanggal Pengajuan</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 blue--text">
                {{ TransaksiDetail.created_at | dateTimeFormat }}
              </v-list-item-title>
            </v-col>

            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Expired :</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 red--text">
                {{ TransaksiDetail.expired_at | dateTimeFormat }}
              </v-list-item-title>
            </v-col>
          </v-row>

          <v-divider light></v-divider>

          <v-row v-if="RekeningUser">
            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >Nama Bank</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ RekeningUser.bank_name }}
              </v-list-item-title>
            </v-col>

            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >A/N Rekening</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ RekeningUser.nama_rekening }}
              </v-list-item-title>
            </v-col>

            <v-col cols="12" sm="6">
              <v-list-item-subtitle class="grey--text"
                >No. Rekening</v-list-item-subtitle
              >
              <v-list-item-title class="headline2 mb-1 black--text">
                {{ RekeningUser.nomor_rekening }}
              </v-list-item-title>
            </v-col>
          </v-row>

          <v-divider light></v-divider>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="headline2 mb-1">Jumlah Tiket</div>
              <v-list-item-subtitle>
                <span style="color: #EF5350"
                  >Rp {{ TransaksiDetail.harga }}</span
                >
                X
                {{ TransaksiDetail.jumlah }} Tiket
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <div class="headline2 mb-1">SubTotal</div>
              <v-list-item-subtitle>
                <span style="color: red">
                  <b>Rp {{ TransaksiDetail.subtotal }}</b>
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <div class="headline2 mb-1">Total Pembayaran</div>
              <v-list-item-subtitle>
                <span style="color: red">
                  <b>Rp {{ TransaksiDetail.total_pembayaran }}</b>
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-row v-if="foto !== null">
            <viewer :images="images">
              <v-col cols="12" sm="12">
                <img :src="gambar" width="150" height="150" />
              </v-col>
            </viewer>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn outlined @click="dialog.Detail = false">Close</v-btn>
          <v-btn
            color="teal darken-1"
            v-if="TransaksiDetail.id_mst_pembayaran_status == 3"
            outlined
            @click="dialog.Extend = true"
            >Perpanjang</v-btn
          >
          <v-btn
            color="red darken-1"
            dark
            v-if="TransaksiDetail.id_mst_order_status != 2"
            @click="dialog.Tolak = true"
            >Tolak</v-btn
          >
          <v-btn
            color="blue darken-1"
            dark
            v-if="TransaksiDetail.id_mst_order_status != 2"
            @click="dialog.Terima = true"
            >Konfirmasi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.Tolak" persistent max-width="500px">
      <v-card>
        <form>
          <v-toolbar dense>
            <v-toolbar-title>Tolak Pembayaran</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="dialog.Tolak = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-select
            :items="MstPembayaranNote"
            v-model="selected.PembayaranNote"
            item-text="note"
            item-value="id"
            label="Alasan Tolak  (Wajib Dipilih)"
            solo
          ></v-select>
          <v-card-text v-if="selected.PembayaranNote == 1">
            <v-textarea label="Alasan Menolak" v-model="Alasan"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="red" dark @click="dialog.Tolak = false">Cancel</v-btn>
            <v-btn color="blue" dark @click="OnTolak(TransaksiDetail.id)"
              >Tolak</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.Terima" persistent max-width="500px">
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Konfirmasi Pembayaran</v-toolbar-title>

          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialog.Terima = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <h4>Apakah Anda Yakin Melakukan Konfirmasi Pembelian Tiket?</h4>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="red" dark @click="dialog.Terima = false">Cancel</v-btn>
          <v-btn color="blue" dark @click="OnKonfirmasi(TransaksiDetail.id)"
            >Terima</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.Extend" persistent max-width="500px">
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Perpanjang Expired</v-toolbar-title>

          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialog.Extend = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <h4>
          Dengan Konfirmasi Akan Merubah Status Menjadi Menunggu Pembayaran dan
          memperpanjang Expired
        </h4>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="red" dark @click="dialog.Extend = false">Cancel</v-btn>
          <v-btn color="blue" dark @click="OnExtend(TransaksiDetail.id)"
            >Perpanjang</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-text-field
      solo
      label="No Order"
      clearable
      prepend-inner-icon="search"
      @keyup.enter="doSeach"
      @click:clear="doClear"
      v-model="search"
    ></v-text-field>

    <v-tabs v-model="tab" fixed-tabs center-active show-arrows>
      <v-tab>
        <v-badge
          dense
          v-if="MenungguPembayaran.count != 0"
          color="pink"
          :content="MenungguPembayaran.count"
          >Menunggu Pembayaran</v-badge
        >
        <div v-else>Menunggu Pembayaran</div>
      </v-tab>
      <v-tab>
        <v-badge
          dense
          v-if="MenungguVerifikasi.count != 0"
          color="pink"
          :content="MenungguVerifikasi.count"
          >Verifikasi</v-badge
        >
        <div v-else>Verifikasi</div>
      </v-tab>
      <v-tab>Diterima</v-tab>
      <v-tab>Ditolak</v-tab>
      <v-tab>Expired</v-tab>
    </v-tabs>

    <v-tabs-items v-if="RenderUnits" v-model="tab">
      <v-tab-item>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page.MenungguPembayaran"
            @input="GetMenungguPembayaran()"
            :length="lengthPage.MenungguPembayaran"
            :total-visible="7"
          ></v-pagination>
        </div>
        <PembelianTiket :units="MenungguPembayaran" :onDetail="GetUnitDetail" />
      </v-tab-item>
      <v-tab-item>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page.MenungguVerifikasi"
            @input="GetMenungguVerifikasi()"
            :length="lengthPage.MenungguVerifikasi"
            :total-visible="7"
          ></v-pagination>
        </div>
        <PembelianTiket :units="MenungguVerifikasi" :onDetail="GetUnitDetail" />
      </v-tab-item>
      <v-tab-item>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page.Diterima"
            @input="GetDiterima()"
            :length="lengthPage.Diterima"
            :total-visible="7"
          ></v-pagination>
        </div>
        <PembelianTiket :units="Diterima" :onDetail="GetUnitDetail" />
      </v-tab-item>

      <v-tab-item>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page.Ditolak"
            @input="GetDitolak()"
            :length="lengthPage.Ditolak"
            :total-visible="7"
          ></v-pagination>
        </div>
        <PembelianTiket :units="Ditolak" :onDetail="GetUnitDetail" />
      </v-tab-item>
      <v-tab-item>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page.Expired"
            @input="GetExpired()"
            :length="lengthPage.Expired"
            :total-visible="7"
          ></v-pagination>
        </div>
        <PembelianTiket :units="Expired" :onDetail="GetUnitDetail" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import PembelianTiket from '@/components/PembelianTiket.vue';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
import moment from 'moment';
Vue.use(Viewer);
export default {
  components: {
    PembelianTiket
  },
  data() {
    return {
      RenderUnits: true,
      tab: null,
      color: { snackbar: '' },
      snackbar: false,
      message: null,
      Alasan: [],
      selected: {
        PembayaranNote: null
      },
      foto: null,
      images: null,
      TransaksiDetail: [],
      dialog: { Detail: false, Tolak: false, Terima: false, Extend: false },
      MstPembayaranNote: [],
      MenungguVerifikasi: [],
      MenungguPembayaran: [],
      Diterima: [],
      Expired: [],
      Ditolak: [],
      gambar: [],
      search: '',
      page: {
        MenungguPembayaran: 1,
        MenungguVerifikasi: 1,
        Diterima: 1,
        Ditolak: 1,
        Expired: 1
      },
      lengthPage: {
        MenungguPembayaran: 1,
        MenungguVerifikasi: 0,
        Diterima: 0,
        Ditolak: 0,
        Expired: 0
      },
      limit: 9,
      offset: 0,
      RekeningUser: [],
      users: []
    };
  },
  mounted() {
    // this.GetUnits();
    this.GetMenungguVerifikasi();
    this.GetMenungguPembayaran();
    this.GetDiterima();
    this.GetDitolak();
    this.GetExpired();
    this.GetMStPembayaranNote();
  },
  created() {
    let users = localStorage.getItem('user');
    this.users = JSON.parse(users);
  },
  methods: {
    forceRerender() {
      this.RenderUnits = false;
      this.$nextTick(() => {
        this.RenderUnits = true;
      });
    },
    async Reload() {
      this.GetMenungguPembayaran();
      this.GetMenungguVerifikasi();
      this.GetDiterima();
      this.GetDitolak();
      this.GetExpired();
      this.forceRerender();
    },
    doClear() {
      this.search = '';
      this.GetMenungguVerifikasi();
      this.GetMenungguPembayaran();
      this.GetDiterima();
      this.GetDitolak();
      this.GetExpired();
    },
    doSeach() {
      this.GetMenungguVerifikasi();
      this.GetMenungguPembayaran();
      this.GetDiterima();
      this.GetDitolak();
      this.GetExpired();
    },
    async GetUnitDetail(id) {
      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v4/order', {
          params: {
            id: id,
            limit: 1
          }
        })
        .then(response => {
          this.TransaksiDetail = response.data.data[0];
          this.GetFotoBukti();
          this.dialog.Detail = true;
          this.GetRekeningUser();
        })
        .catch(error => {
          console.log(error);
          this.color.snackbar = 'error';
          this.message = error;
          this.snackbar = true;
        });
    },

    go() {
      var offset = (this.offset = (this.page - 1) * this.limit);
      console.log(offset);
    },
    async GetRekeningUser() {
      this.RekeningUser = '';
      const rekening = await this.$req.get(this.$root.$baseapi.user+'/user/v3/user/rekening', {
        params: {
          id_app_user: this.TransaksiDetail.id_pembeli,
          limit: 1
        }
      });
      this.RekeningUser = rekening.data.data[0];
    },

    async GetFotoBukti() {
      this.foto = null;

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v3/upload_pembayaran', {
          params: {
            id_pembayaran: this.TransaksiDetail.id_pembayaran
          }
        })
        .then(response => {
          this.foto = response.data.data;
          this.GetGambar();
        })
        .catch(error => {
          console.log(error);
          this.color.snackbar = 'error';
          this.message = 'Foto Bukti Pembayaran Tidak Tersedia';
          this.snackbar = true;
        });
    },
    async GetGambar() {
      this.$img_transaksi
        .get(this.foto[0].foto, { responseType: 'arraybuffer' })
        .then(response => {
          var bytes = new Uint8Array(response.data);
          var binary = bytes.reduce(
            (data, b) => (data += String.fromCharCode(b)),
            ''
          );
          this.gambar = 'data:image/jpeg;base64,' + btoa(binary);
        })
        .catch(error => {
          console.log(error);
          this.color.snackbar = 'error';
          this.message = error;
          this.snackbar = true;
        });
    },

    async GetMenungguVerifikasi() {
      var offset = (this.offset =
        (this.page.MenungguVerifikasi - 1) * this.limit);

      var params = new URLSearchParams();
      params.append('no_order', this.search);
      params.append('offset', offset);
      params.append('limit', this.limit);
      params.append('id_mst_iklan_jenis', 1);
      params.append('id_order_mst_type', 1);
      params.append('id_mst_order_jenis_iklan', 1);
      params.append('id_mst_pembayaran_status', 4);

      var request = {
        params: params
      };

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v4/order', request)
        .then(response => {
          this.MenungguVerifikasi = response.data;
          var mod = this.MenungguVerifikasi.count % this.limit;
          console.log('mod', mod);
          this.lengthPage.MenungguVerifikasi =
            (this.MenungguVerifikasi.count - mod) / this.limit + 1;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async GetMenungguPembayaran() {
      var offset = (this.offset =
        (this.page.MenungguPembayaran - 1) * this.limit);

      var params = new URLSearchParams();
      params.append('no_order', this.search);
      params.append('offset', offset);
      params.append('limit', this.limit);
      params.append('id_mst_iklan_jenis', 1);
      params.append('id_order_mst_type', 1);
      params.append('id_mst_order_jenis_iklan', 1);
      params.append('id_mst_pembayaran_status', 1);

      var request = {
        params: params
      };

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v4/order', request)
        .then(response => {
          this.MenungguPembayaran = response.data;
          var mod = this.MenungguPembayaran.count % this.limit;
          console.log('mod', mod);
          this.lengthPage.MenungguPembayaran =
            (this.MenungguPembayaran.count - mod) / this.limit + 1;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async GetDiterima() {
      var offset = (this.offset = (this.page.Diterima - 1) * this.limit);

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v4/order', {
          params: {
            no_order: this.search,
            offset: offset,
            limit: this.limit,
            id_mst_iklan_jenis: 1,
            id_order_mst_type: 1,
            id_mst_order_jenis_iklan: 1,
            id_mst_pembayaran_status: 2
          }
        })
        .then(response => {
          this.Diterima = response.data;
          var mod = this.Diterima.count % this.limit;
          this.lengthPage.Diterima =
            (this.Diterima.count - mod) / this.limit + 1;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async GetDitolak() {
      var offset = (this.offset = (this.page.Ditolak - 1) * this.limit);

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v4/order', {
          params: {
            no_order: this.search,
            offset: offset,
            limit: this.limit,
            id_mst_iklan_jenis: 1,
            id_order_mst_type: 1,
            id_mst_order_jenis_iklan: 1,
            id_mst_pembayaran_status: 6
          }
        })
        .then(response => {
          this.Ditolak = response.data;
          var mod = this.Ditolak.count % this.limit;
          this.lengthPage.Ditolak = (this.Ditolak.count - mod) / this.limit + 1;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async GetExpired() {
      var offset = (this.offset = (this.page.Expired - 1) * this.limit);

      await this.$req
        .get(this.$root.$baseapi.transaksi+'/transaksi/v4/order', {
          params: {
            no_order: this.search,
            offset: offset,
            limit: this.limit,
            id_mst_iklan_jenis: 1,
            id_order_mst_type: 1,
            id_mst_order_jenis_iklan: 1,
            id_mst_pembayaran_status: 3
          }
        })
        .then(response => {
          this.Expired = response.data;
          var mod = this.Expired.count % this.limit;
          this.lengthPage.Expired = (this.Expired.count - mod) / this.limit + 1;
        })
        .catch(error => {
          console.log(error);
        });
    },

    async GetMstStatusTolak() {
      this.MstStatusTolak = [];
      const status_tolak = await this.$req.get(this.$root.$baseapi.master+'/master/v3/mst_moderasi');

      this.MstStatusTolak = status_tolak.data.data;
    },
    async OnTolak(id) {
      let formData = new FormData();
      formData.append('id', id);
      formData.append('id_biz_user', this.users.id);
      formData.append('id_mst_pembayaran_note', this.selected.PembayaranNote);
      if (this.Alasan != '') {
        formData.append('note_detail', this.Alasan);
      }

      const resp = await this.$req
        .post(this.$root.$baseapi.transaksi+'/transaksi/v3/tolak_pembayaran', formData)
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          return error.response;
        });

      console.log('resp', resp);
      if (resp.status == 200) {
        this.color.snackbar = 'success';
        this.message = resp.data.api_message;

        this.Reload();
        this.dialog.Detail = false;
        this.dialog.Tolak = false;
        this.Alasan = '';
      } else {
        this.color.snackbar = 'error';
        this.message = resp.data.api_message;
      }

      this.snackbar = true;
    },
    async OnKonfirmasi(id) {
      let formData = new FormData();
      formData.append('id', id);
      formData.append('id_biz_user', this.users.id);

      const resp = await this.$req
        .post(this.$root.$baseapi.transaksi+'/transaksi/v3/konfirmasi_pembayaran_tiket', formData)
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          return error.response;
        });

      console.log('resp', resp);
      if (resp.status == 200) {
        this.color.snackbar = 'success';
        this.message = resp.data.api_message;

        this.Reload();
        this.dialog.Detail = false;
        this.dialog.Terima = false;
      } else {
        this.color.snackbar = 'error';
        this.message = resp.data.api_message;
      }

      this.snackbar = true;
    },
    async OnExtend() {
      let formData = new FormData();
      formData.append('id', this.TransaksiDetail.id);
      formData.append('id_biz_user', this.users.id);

      const resp = await this.$req
        .post(this.$root.$baseapi.transaksi+'/transaksi/v3/perpanjang_kadaluarsa', formData)
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          return error.response;
        });

      console.log('resp', resp);
      if (resp.status == 200) {
        this.color.snackbar = 'success';
        this.message = resp.data.api_message;

        this.Reload();
        this.dialog.Detail = false;
        this.dialog.Extend = false;
      } else {
        this.color.snackbar = 'error';
        this.message = resp.data.api_message;
      }

      this.snackbar = true;
    },
    async GetMStPembayaranNote() {
      this.MstPembayaranNote = [];
      const status_tolak = await this.$req.get(
        this.$root.$baseapi.transaksi+'/transaksi/v3/mst_pembayaran_note'
      );
      this.MstPembayaranNote = status_tolak.data.data;
    }
  },
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  }
};
</script>
